import { Component, OnInit, ViewChild } from '@angular/core';
import { DeniedQuotaModel, DeniedQuotasReportRequest } from '@app/models/DeniedQuotasReports.model';
import { PaginationComponent } from '@components/layout/pagination/pagination.component';
import { CONSTANTS } from '@config/constants';
import { PermissionModel } from '@models/permission.model';
import { AuthService } from '@services/auth.service';
import { HelperService } from '@services/helper.service';
import { ModalService } from '@services/modal.service';
import { ReportsService } from '@services/reports.service';
import { UsersService } from '@services/users.service';
import * as FileSaver from 'file-saver';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-tab-denied-quotas',
  templateUrl: './tab-denied-quotas.component.html',
  styleUrls: ['./tab-denied-quotas.component.scss']
})
export class TabDeniedQuotasComponent implements OnInit {

  @ViewChild('paginationComponent') paginationComponent: PaginationComponent;
  public totalPages = 1;
  public pageLimit = 6;
  public minInput: Date = environment.production? moment().startOf('day').subtract(3, 'months').toDate(): moment().startOf('year').subtract(1, 'year').toDate();
  public reports: Array<any>;
  public reportsPaginated: DeniedQuotaModel[] = [
  ];
  public currentPageA = 0;

  public reportRequest: DeniedQuotasReportRequest = {
    endDate: moment().toDate(),
    startDate: moment().subtract(7, 'days').toDate(),
  } as DeniedQuotasReportRequest;

  public permissions: Array<PermissionModel>;
  public constants = CONSTANTS;
  public donwloadReport = 'A';

  constructor(
    private auth: AuthService,
    public helper: HelperService,
    private spinner: NgxSpinnerService,
    private reportsService: ReportsService,
    public modal: ModalService,
    private usersService: UsersService
  ) { }

  ngOnInit() {
    this.getDeniedReports(1);
    this.permissions = this.usersService.permissions;
    const permissionStatus = this.permissions.filter(
      (permission) => permission.idOption === '21'
    );
    if (permissionStatus.length > 0) {
      this.donwloadReport = permissionStatus[0].status;
    }
  }

  pageSelected({ currentPage }) {
    this.getDeniedReports(currentPage, false);
    this.currentPageA = currentPage - 1;
  }

  search(dateRange: any) {
    if (dateRange[0]) {
      this.reportRequest.startDate = dateRange[0];
    }
    if (dateRange[1]) {
      this.reportRequest.endDate = dateRange[1];
    }
    if (dateRange[0] && dateRange[1]) {
      this.getDeniedReports(1);
    }
  }






  getDeniedReports(currentPage: number, download: boolean = false ) {
    this.spinner.show();
    this.reportRequest.page = currentPage;
    this.reportRequest.download = download
    this.reportsService.getDeniedQuotasReport(this.reportRequest).subscribe(
      (report) => {
        if (report.ok && download===false) {
          this.reportsPaginated = report.data;
          this.totalPages = report.totalPages
        } else if (download) {
          this.downloadTransactionsExcel(report.data)
        }
        this.spinner.hide();
      },
      (err: any) => {
        this.spinner.hide();
        this.reportsPaginated=[]
       /*  Swal.fire({
          type: 'error',
          title: 'Error:',
          text: `Por favor intente más tarde. ${err.error.id_tx ? err.error.id_tx : ''}`,
        }); */
      }
    );
  }

  downloadTransactionsExcel(data: any) {

    const byteCharacters = atob(data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray],);
    FileSaver.saveAs(blob, 'reporte-cupos-negados.xlsx');

  }


  noPay() {
    this.modal.show('nopayConfirm');
  }

}
